import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const Promocional = () => {
  const [ref, isVisible] = useScrollAnimation();

  const handleConsultarClick = () => {
    const element = document.querySelector('#consulta-multas');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-5 text-white" style={{ backgroundColor: '#1E3A5F' }}>
      <div className="container" ref={ref}>
        <div className="row">
          <div className="col-lg-8 mx-auto text-center">
            <h2 className={`display-5 fw-bold mb-4 ${isVisible ? 'animate-fade-in' : ''}`}>
              Tu multa más antigua, nuestra mejor carta de presentación
            </h2>
            <p className={`lead mb-4 ${isVisible ? 'animate-fade-in' : ''}`} style={{ animationDelay: '0.2s' }}>
              Te la resolvemos con un precio único en el mercado para que conozcas cómo trabajamos. Nuestro objetivo principal es anular las fotomultas y evitar que se consoliden antecedentes que puedan afectar tu historial y el de tu vehículo.
            </p>
            <button 
              className={`btn btn-light btn-lg px-5 py-3 fw-bold ${isVisible ? 'animate-fade-in' : ''}`} 
              style={{ animationDelay: '0.4s' }}
              onClick={handleConsultarClick}
            >
              Consultar Mis Fotomultas
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Promocional;

